import { IconChevron } from "../icons/Icons";

/**
 * A single collapsible HG accordion row with a table inside.
 * Props: label, headers, rows (array of cell arrays), open, onToggle,
 *        grantColIndex (column index that shows ✓/✗ buttons),
 *        onGrant(rowIndex), onDeny(rowIndex)
 */
export default function HGSection({ label, headers, rows, open, onToggle, grantColIndex, onGrant, onDeny }) {
  return (
    <div style={{ marginBottom: 3 }}>
      {/* Header bar */}
      <div
        onClick={onToggle}
        style={{
          background: "#1e6b6b", color: "white", fontSize: 11, fontWeight: 600,
          padding: "6px 10px", borderRadius: open ? "3px 3px 0 0" : 3,
          cursor: "pointer", display: "flex", alignItems: "center",
          justifyContent: "space-between", userSelect: "none",
        }}
      >
        {label}
        <IconChevron open={open} />
      </div>      {/* Expandable table */}
      {open && (
        <div style={{ border: "1px solid #d0e4e4", borderTop: "none", borderRadius: "0 0 3px 3px", marginBottom: 2, overflow: "hidden" }}>
          {/* Sticky header + scrollable body wrapper */}
          <div style={{ maxHeight: rows.length > 5 ? 180 : "none", overflowY: rows.length > 5 ? "auto" : "visible" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 10 }}>
            <thead>              <tr style={{ background: "#eaf4f4" }}>
                {headers.map(h => (
                  <th key={h} style={{ textAlign: "left", color: "#1e6b6b", fontWeight: 700, fontSize: 10, padding: "5px 6px", borderBottom: "1px solid #d0e4e4", whiteSpace: "nowrap", position: "sticky", top: 0, background: "#eaf4f4", zIndex: 1 }}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={headers.length} style={{ padding: "8px 6px", color: "#aaa", fontStyle: "italic", fontSize: 10, textAlign: "center" }}>
                    No entries
                  </td>
                </tr>
              ) : (
                rows.map((r, i) => (
                  <tr key={i} style={{ background: i % 2 === 0 ? "white" : "#f4fbfb" }}>
                    {r.map((cell, ci) => {
                      // Grant column → render ✓ / ✗ buttons
                      if (grantColIndex !== undefined && ci === grantColIndex) {
                        return (
                          <td key={ci} style={{ padding: "3px 6px", borderBottom: "1px solid #f0f0f0" }}>
                            <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                              {/* ✓ Grant */}
                              <button
                                onClick={e => { e.stopPropagation(); onGrant && onGrant(i); }}
                                title="Grant — advance to next stage"
                                style={{
                                  width: 22, height: 22, borderRadius: 4, border: "1.5px solid #28a745",
                                  background: "#eafaf1", color: "#28a745", cursor: "pointer",
                                  display: "flex", alignItems: "center", justifyContent: "center",
                                  fontSize: 12, fontWeight: 700, lineHeight: 1, padding: 0,
                                  transition: "background 0.15s",
                                }}
                                onMouseEnter={e => e.currentTarget.style.background = "#28a745"}
                                onMouseLeave={e => e.currentTarget.style.background = "#eafaf1"}
                                onMouseEnterCapture={e => e.currentTarget.style.color = "white"}
                                onMouseLeaveCapture={e => e.currentTarget.style.color = "#28a745"}
                              >✓</button>
                              {/* ✗ Deny */}
                              <button
                                onClick={e => { e.stopPropagation(); onDeny && onDeny(i); }}
                                title="Deny — keep in current stage"
                                style={{
                                  width: 22, height: 22, borderRadius: 4, border: "1.5px solid #dc3545",
                                  background: "#fdf3f4", color: "#dc3545", cursor: "pointer",
                                  display: "flex", alignItems: "center", justifyContent: "center",
                                  fontSize: 13, fontWeight: 700, lineHeight: 1, padding: 0,
                                  transition: "background 0.15s",
                                }}
                                onMouseEnter={e => e.currentTarget.style.background = "#dc3545"}
                                onMouseLeave={e => e.currentTarget.style.background = "#fdf3f4"}
                                onMouseEnterCapture={e => e.currentTarget.style.color = "white"}
                                onMouseLeaveCapture={e => e.currentTarget.style.color = "#dc3545"}
                              >✕</button>
                            </div>
                          </td>
                        );
                      }
                      const isNegative = typeof cell === "string" && cell.startsWith("-");
                      return (
                        <td key={ci} style={{ padding: "4px 6px", borderBottom: "1px solid #f0f0f0", color: isNegative ? "#c0392b" : "#333", fontWeight: isNegative ? 600 : 400 }}>
                          {cell}
                        </td>
                      );
                    })}
                  </tr>
                ))
              )}            </tbody>
          </table>
          </div>
        </div>
      )}
    </div>
  );
}
